import CandleChart from "../CandleChart/CandleChart";
const MarketOverview = ({
  title,
  symbol,

  quote,

  maData = [],

  chartData = [],

  loading,

  error,

  onDelete,

  onRefresh,

  showDelete = false,

  children,
}) => {
  const ohlc = quote?.ohlc || {};

  const ltp = quote?.last_price;

  const open = ohlc?.open;

  const high = ohlc?.high;

  const low = ohlc?.low;

  const prevClose = ohlc?.close;

  const priceDiff = ltp && prevClose ? Number((ltp - prevClose).toFixed(2)) : 0;

  const percentChange =
    ltp && prevClose
      ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
      : 0;

  if (loading) {
    return <p>Fetching data...</p>;
  }

  if (error) {
    return (
      <div
        style={{
          marginTop: "20px",
          padding: "14px",
          borderLeft: "5px solid #dc2626",
          background: "#fee2e2",
          color: "#7f1d1d",
          fontWeight: 600,
          borderRadius: "8px",
        }}
      >
        {error}
      </div>
    );
  }

  return (
    <div className="stockpro-page">
      <section className="stockpro-header">
        <div className="stockpro-price-title">
          <div className="stockpro-head-block">
            <div className="stockpro-title-block">
              <h1>{title}</h1>

              <p className="stockpro-symbol stock-tag">{symbol}</p>
            </div>

            <div className="stockpro-price-block">
              <h2>₹{ltp || "—"}</h2>

              <p
                className={
                  percentChange >= 0 ? "stockpro-green" : "stockpro-red"
                }
              >
                {percentChange >= 0 ? "▲" : "▼"}
                {priceDiff}
                <span>
                  ({percentChange > 0 ? `+${percentChange}` : percentChange}
                  %)
                </span>
              </p>
            </div>
          </div>

          <div className="stockpro-header-metrics">
            <div className="stockpro-metric">
              <span>Open</span>
              <b>₹{open || "—"}</b>
            </div>

            <div className="stockpro-metric">
              <span>High</span>
              <b>₹{high || "—"}</b>
            </div>

            <div className="stockpro-metric">
              <span>Low</span>
              <b>₹{low || "—"}</b>
            </div>

            <div className="stockpro-metric">
              <span>Prev Close</span>
              <b>₹{prevClose || "—"}</b>
            </div>
          </div>
        </div>
      </section>

      <section className="stockpro-grid">
        <div className="stockpro-main">
          <div className="stockpro-two-col">
            <section className="stockpro-card">
              <div className="stockpro-card-head">
                <h3>Moving Averages</h3>

                {showDelete && <button onClick={onDelete}>Delete</button>}
              </div>

              <div className="stockpro-return-grid">
                {maData?.map((item) => (
                  <div key={item.name} className="stockpro-return-item">
                    <span>{item.name}</span>

                    <b>EMA {item?.ema?.toFixed?.(2)}</b>

                    <p>SMA {item?.sma?.toFixed?.(2)}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="stockpro-card">
              <div className="stockpro-card-head">
                <h3>Chart</h3>

                {onRefresh && <button onClick={onRefresh}>Refresh</button>}
              </div>

              <CandleChart data={chartData} />
            </section>
          </div>
        </div>
      </section>

      {children}
    </div>
  );
};

export default MarketOverview;
